// extracted by css-extract-rspack-plugin
export default {"sideBarNavPadding":"_1cd31cdc","sideBarNavPaddingCollapsed":"_6763a5d3"};